import React from 'react';

import { keyframes } from '@compiled/react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import GiftIcon from '@atlaskit/icon-lab/core/gift';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { chatHeaderTestIds } from '../../../common/constants/constants';
import { MenuItem } from '../../../common/ui/chat-header-menu/menu-item';
import { chatHeaderMessages as messages } from '../messages';

const shakeKeyframes = keyframes({
	'0%, 100%': {
		transform: 'translateX(0)',
	},
	'20%': {
		transform: 'translateX(-1px) rotate(-8deg)',
	},
	'40%': {
		transform: 'translateX(1px) rotate(8deg)',
	},
	'60%': {
		transform: 'translateX(-1px) rotate(-6deg)',
	},
	'80%': {
		transform: 'translateX(1px) rotate(6deg)',
	},
});

const styles = cssMap({
	shakeIconWrapper: {
		display: 'inline-flex',
		animation: `${shakeKeyframes} 1000ms ease-in-out 2`,
		'@media (prefers-reduced-motion: reduce)': {
			animation: 'none',
		},
	},
});

export type WhatsNewMenuItemProps = {
	onToggleOptionsMenu: () => void;
};

export const WhatsNewMenuItem = ({
	onToggleOptionsMenu,
}: WhatsNewMenuItemProps): React.JSX.Element => {
	const { formatMessage: fm } = useIntl();

	return (
		<MenuItem
			testId={chatHeaderTestIds.whatsNewButton}
			label={fm(messages.chatHeaderWhatsNewButtonText)}
			icon={
				<Box
					as="span"
					xcss={fg('ai_mate_whats_new_has_update') ? styles.shakeIconWrapper : undefined}
				>
					<GiftIcon
						label={fm(messages.chatHeaderWhatsNewIconLabel)}
						color={
							fg('ai_mate_whats_new_has_update')
								? token('color.icon.discovery')
								: token('color.icon.subtle')
						}
					/>
				</Box>
			}
			onClick={() => {
				window.open(
					'https://www.atlassian.com/software/rovo/features/whats-new',
					'_blank',
					'noopener,noreferrer',
				);
				onToggleOptionsMenu();
			}}
			isExternalLink
			componentName="chatHeaderWhatsNewMenuItem"
		/>
	);
};
